import "./AddFoodModal.css";
import FoodForm from "../FoodForm/FoodForm";

function AddFoodModal({
  open,
  onClose,
  onSubmit,
  loading = false,
}) {
  if (!open) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
    >
      <div
        className="food-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}

        <div className="food-modal-header">

          <h2>Add New Food</h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ✕
          </button>

        </div>

        {/* Body */}

        <div className="food-modal-body">

          <FoodForm
            onSubmit={onSubmit}
            loading={loading}
          />

        </div>

      </div>
    </div>
  );
}

export default AddFoodModal;